import { ValidationSchema, Validator } from "@bps/validator";

import { SelectorFormValues } from "./formUtils";

export const selectorFormValidator = new Validator<SelectorFormValues>();

const nameRequired = selectorFormValidator.string().required();
const rulesInteger = selectorFormValidator.array<"rules">().itemArray({
  attributeType: selectorFormValidator.string().required(),
  value: selectorFormValidator.custom<"rules">().predicate({
    when: (_, rule) => {
      return rule.valueDataType === "INTEGER";
    },
    then: selectorFormValidator
      .number()
      .isInteger({ message: "Value must be an integer." })
  })
});

const rulesValueRequired = selectorFormValidator.array<"rules">().itemArray({
  value: selectorFormValidator.string().required()
});

export const selectorFormSchema: ValidationSchema<SelectorFormValues> = {
  rules: rulesInteger && rulesValueRequired,
  name: nameRequired
};
